import { Button, styled } from '@mui/material'

export const CardContainer = styled('div')(({ theme }) => ({
  padding: '1rem',
  width: 520,
  [theme.breakpoints.down(575)]: {
    width: 'auto',
  },
}))

export const Body = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: 6,
  '& >.information': {
    width: 146,
    marginRight: '0.5rem',
    [theme.breakpoints.down(575)]: {
      width: 130,
    },
  },
}))

export const MainInfo = styled('div')(({ theme }) => ({
  display: 'flex',
  [theme.breakpoints.down(575)]: {
    display: 'block',
  },
  '& >div:first-of-type': {
    display: 'flex',
    '& >p': {
      marginLeft: 10,
    },
  },
  '& >div:last-of-type': {
    width: '100%',
    marginLeft: 10,
  },
  '& img': {
    cursor: 'pointer',
    width: 130,
    height: 130,
    maxWidth: 130,
    maxHeight: 130,
    borderRadius: 10,
    [theme.breakpoints.down(575)]: {
      maxWidth: 60,
      maxHeight: 60,
      width: 60,
      height: 60,
    },
  },
}))

export const BottomContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: '',
  marginTop: '0.5rem',
  '& >a': {
    textDecoration: 'none',
  },
  '& >div': {
    width: 'auto',
    [theme.breakpoints.down(575)]: {
      width: 190,
      display: 'flex',
      flexWrap: 'wrap',
      transform: 'scale(.8) translate(-26px, -8px)',
    },
    '& >svg': {
      marginBottom: -4,
      marginRight: 4,
    },
    '& >a': {
      whiteSpace: 'nowrap',
    },
    '& .separator': {
      margin: '0 0.4rem',
    },
  },
}))

export const BookButton = styled(Button)(({ theme }) => ({
  width: 160,
  '&:hover': {
    color: theme.palette.primary.main,
  },
  [theme.breakpoints.down(575)]: {
    width: 125,
  },
}))

export const Slots = styled('div')(({ theme }) => ({
  width: 176,
  margin: 'auto 0',
  [theme.breakpoints.down(575)]: {
    width: 190,
    transform: 'scale(0.8) translate(18px)',
  },
  '& >p:first-of-type': {
    fontSize: '1rem',
    display: 'flex',
    marginBottom: '0.3rem',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.grey[400],
  },
}))

export const SlotOption = styled('div')<{
  available: number
}>(({ theme, available }) => ({
  fontSize: '1rem',
  display: 'flex',

  margin: '0 auto 0.3rem',
  justifyContent: 'flex-start',
  alignItems: 'center',
  color: available ? theme.palette.primary.main : theme.palette.grey[400],
  '& >div': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '26px',
    height: '26px',
    marginRight: '0.6rem',
    borderRadius: '50%',
    backgroundColor: available
      ? theme.palette.primary.main
      : theme.palette.grey[400],
    '& >svg': {
      fill: theme.palette.common.white,
    },
  },
}))
